import styled from 'styled-components';
export var LabelContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__LabelContainer",
  componentId: "tscr73-0"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
export var LabelText = /*#__PURE__*/styled.label.withConfig({
  displayName: "style__LabelText",
  componentId: "tscr73-1"
})(["font-family:", ";font-size:", ";margin-bottom:", ";margin-right:", ";display:block;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.fontSize.ft14;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.sp4;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing.sp4;
});